<div echarts [options]="commonChartOptions" [merge]="chartData()" class="chart"></div>

<div class="inputs">
	@for (
		competenceCategoryDistributionEntry of categoryDistributionForm.controls;
		track competenceCategoryDistributionEntry.controls.competenceCategoryId
	) {
		<!-- PERCENTAGE INPUT -->
		<label class="percentageInputLabel">{{
			competenceCategoryMap().get(competenceCategoryDistributionEntry.value.competenceCategoryId)?.name
		}}</label>
		<mat-form-field subscriptSizing="dynamic" class="percentageInput">
			<mat-label>{{ T.COMPETENCE_CATEGORY_PANEL_PERCENTAGE_LABEL | translate }}</mat-label>
			<input
				matInput
				(change)="handleNumberInputValueChange($event, $index)"
				[value]="convertToPercentage | wrapFn: competenceCategoryDistributionEntry.value.percentage"
				min="0"
				max="100"
				type="number"
			/>
			<span matTextSuffix>%&nbsp;</span>
			<mat-error>{{ T.COMPETENCE_CATEGORY_PANEL_INVALID_PERCENTAGE | translate }}</mat-error>
		</mat-form-field>
	}
	<div class="info">
		<span class="infoLabel">{{ T.COMPETENCE_CATEGORY_PANEL_TOTAL_PERCENTAGES | translate }} {{ totalPercentages() }}%</span>
		<span class="infoLabel">{{ T.COMPETENCE_CATEGORY_PANEL_REMAINING_PERCENTAGES | translate }} {{ remainingPercentages() }}%</span>
	</div>
</div>

@if (categoryDistributionForm.hasError("invalidDistribution")) {
	<mat-error>{{ T.COMPETENCE_CATEGORY_PANEL_INVALID_SUM | translate }}</mat-error>
}
